<template>
    <b-table-lite :items="ldapAttributeList"/>
</template>

<script>
export default {
    name: 'LdapDetails',
    computed: {
        ldapAttributeList: function () {
            return Object.entries(this.ldapAttributes).sort().map(([k,v]) => ({attribute: k, value: v}))
        }
    },
    props: {
        ldapAttributes: {
            type: Object,
            default: function () {
                return {}
            }
        }
    }
}
</script>